import { render } from "./Private.vue?vue&type=template&id=0ca4c33e&scoped=true"
import script from "./Private.vue?vue&type=script&lang=js"
export * from "./Private.vue?vue&type=script&lang=js"

import "./Private.vue?vue&type=style&index=0&id=0ca4c33e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4c33e"]])

export default __exports__